const dimensionCache = /* @__PURE__ */ new Map();
export async function getImageSize(src) {
  if (!dimensionCache.has(src)) {
    const { width, height } = await new Promise((resolve) => {
      let img = new global.Image();
      const resolvePromise = () => {
        const dimension = {
          width: img?.naturalWidth || 0,
          height: img?.naturalHeight || 0
        };
        img = void 0;
        resolve(dimension);
      };
      img.onload = () => resolvePromise();
      img.onerror = () => resolvePromise();
      img.src = src;
    });
    dimensionCache.set(src, { width, height });
  }
  return dimensionCache.get(src);
}
